import _ from 'lodash';
import Section from "../components/Section";
import {Button} from "../components/Button";
import UIState from "../store/uiState";
import {ModalTypes, STAKING_DISABLED} from "../constants";
import {useDispatch, useSelector} from "react-redux";
import {createSelector} from "reselect";
import {formatBalance, truncate} from "../utils";
import Wallet, {selectNFTBalances, selectStoreProductsByType} from "../store/models/wallet";
import {useEffect, useRef, useState} from "react";
import {usePageVisibility} from "../hooks/usePageVisibility";
import {StakeAPYCTA, StakeAPYInfo} from "../components/CTAPill";
import {useTranslation} from "react-i18next";
import logo from "../assets/logos/grove@2x.png";
import metamaskLogo from "../assets/wallets/metamask-white@2x.png";
import thetaWalletLogo from "../assets/wallets/theta-wallet-white@2x.png";
import CharacterViewer from "../components/CharacterViewer";
import {Tab, TabList, Tabs} from "react-tabs";
import tokenIcon from "../assets/logos/grove@2x.png";
import cardCheckmark from "../assets/icons/card/purple-checkmark@2x.png";
import cardNew from "../assets/icons/card/new@2x.png";
import classNames from "classnames";
import PurchaseButton from "../components/PurchaseButton";
import GetMoreGroveButton from "../components/GetMoreGroveButton";
import useMediaQuery from "../hooks/useMediaQuery";
import exclamationIcon from "../assets/icons/card/alert@2x.png";
import Items, {getItemById} from "../items";
import Sqids from "sqids";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import cardSoldOut from "../assets/icons/card/sold-out@2x.png";
import cardExclusive from "../assets/icons/card/exclusive@2x.png";

const moment = require("moment");
const sqids = new Sqids();
window.sqids = sqids;

const ItemCard = ({item}) => {
    return (
        <div className={'BuilderItemCard'}
        >
            <div className={'BuilderItemCard__image'}>
                <img src={`${item.image}`}
                     alt={item.name}/>
            </div>
            <div className={'BuilderItemCard__details'}>
                <div className={'BuilderItemCard__details__name'}>
                    {item.name}
                </div>
            </div>
        </div>
    );
}

const CharacterPage = () => {
    const navigate = useNavigate();
    let params = useParams();
    let specId = params?.id;
    const [characterId, weaponId, backSwagId] = sqids.decode(specId);
    const isMobile = useMediaQuery(768);
    const [dimensions, setDimensions] = useState(null);
    const viewerRef = useRef(null);
    const characterItem = getItemById(characterId);
    const weaponItem = getItemById(weaponId);
    const backSwagItem = getItemById(backSwagId);
    const [characterSpec, setCharacterSpec] = useState({
        character: characterItem?.modelName,
        weapon: weaponItem?.modelName,
        back_swag: backSwagItem?.modelName
    });

    useEffect(() => {
        const updateDimensions = () => {
            if (viewerRef.current) {
                setDimensions({
                    x: viewerRef.current.offsetLeft,
                    y: viewerRef.current.offsetTop,
                    width: viewerRef.current.offsetWidth,
                    height: viewerRef.current.offsetHeight,
                });
            }
        };

        // Initial size update
        updateDimensions();

        // Update size on window resize
        window.addEventListener('resize', updateDimensions);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    return (
        <div className={'Page CharacterPage'}>
            <div className={'CharacterPage__content'}>
                <div className={'CharacterPaneViewer'}
                     ref={viewerRef}>
                    <div className={'CharacterPaneViewer__fixed-container'}
                         style={{
                             left: dimensions ? dimensions.x : 0,
                             top: (dimensions ? dimensions.y : 0) + (isMobile ? 0 : 0),
                         }}
                    >
                        {
                            dimensions &&
                            <CharacterViewer height={Math.min((dimensions.height - 270), 800)}
                                             width={dimensions.width}
                                             spec={characterSpec}
                            />
                        }
                        <div className={'CharacterPage__items'}>
                            <ItemCard item={characterItem}/>
                            <ItemCard item={weaponItem}/>
                            <ItemCard item={backSwagItem}/>
                        </div>
                        <div className={'CharacterPaneViewer__footer'}>
                            <Button color={'red'}
                                    size={'large'}
                                    onClick={() => {
                                        navigate('/');
                                    }}
                            >
                                Create Yours Now
                            </Button>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    )
};

export default CharacterPage;